import { Routes } from '@angular/router';
import {
  CTX_CUSTOMER_ROUTES,
  CtxAuthBaseLayoutComponent,
  CustomerForgotPasswordComponent,
  CustomerLoginComponent,
  CustomerResetPasswordComponent,
  CustomerTwoFactorLoginComponent,
} from 'ng-ui';

export const routes: Routes = [
  {
    path: '',
    component: CtxAuthBaseLayoutComponent,
    children: [
      {
        path: '',
        redirectTo: CTX_CUSTOMER_ROUTES.getLeaf('login').leafNode.path,
        pathMatch: 'full',
      },
      {
        path: CTX_CUSTOMER_ROUTES.getLeaf('login').leafNode.path,
        title: CTX_CUSTOMER_ROUTES.getRouteTitle(
          CTX_CUSTOMER_ROUTES.getLeaf('login').leafNode.label
        ),
        component: CustomerLoginComponent,
      },
      {
        path: CTX_CUSTOMER_ROUTES.getLeaf('reset-password').leafNode.path,
        title: CTX_CUSTOMER_ROUTES.getRouteTitle(
          CTX_CUSTOMER_ROUTES.getLeaf('reset-password').leafNode.label
        ),
        component: CustomerResetPasswordComponent,
      },
      {
        path: CTX_CUSTOMER_ROUTES.getLeaf('forgot-password').leafNode.path,
        title: CTX_CUSTOMER_ROUTES.getRouteTitle(
          CTX_CUSTOMER_ROUTES.getLeaf('forgot-password').leafNode.label
        ),
        component: CustomerForgotPasswordComponent,
      },
      {
        path: CTX_CUSTOMER_ROUTES.getLeaf('two-factor').leafNode.path,
        title: CTX_CUSTOMER_ROUTES.getRouteTitle(
          CTX_CUSTOMER_ROUTES.getLeaf('two-factor').leafNode.label
        ),
        component: CustomerTwoFactorLoginComponent,
      },
    ],
  },
];
